import { DateTime } from "luxon";

export function morningstarFormDefaults(morningstar) {
  const stored = morningstar || {};
  return {
    "morningstar-manual": Boolean(stored.manual),
    "morningstar-rating":
      stored.rating === null || stored.rating === undefined
        ? ""
        : String(stored.rating),
    "morningstar-category": stored.category || "",
    "morningstar-ratingdate": stored.rating_date
      ? DateTime.fromISO(stored.rating_date).toJSDate()
      : null,
  };
}

export function buildMorningstarBody(formValues) {
  if (!formValues["morningstar-manual"]) {
    return { manual: false };
  }
  const rating = formValues["morningstar-rating"];
  const ratingDate = formValues["morningstar-ratingdate"];
  return {
    manual: true,
    rating:
      rating === undefined || rating === null || rating === ""
        ? null
        : Number(rating),
    category: (formValues["morningstar-category"] || "").trim() || null,
    rating_date: ratingDate
      ? DateTime.fromJSDate(new Date(ratingDate)).toFormat("yyyy-MM-dd")
      : null,
  };
}

// Omitting the key leaves the stored override alone, so a save that never
// touched this tab cannot release or overwrite another admin's lock.
export function morningstarChange(formValues, stored) {
  const body = buildMorningstarBody(formValues);
  const unchanged = buildMorningstarBody(morningstarFormDefaults(stored));
  return JSON.stringify(body) === JSON.stringify(unchanged) ? undefined : body;
}
